import { makeAutoObservable, runInAction } from 'mobx';
import type { Key } from 'react';

import {cmApi } from '@src/api';
import type { CmApi} from '@src/api';

import { preloaderStore } from '../preloaderStore';
import { toViewModel } from './toViewModel';
import type { TreeViewInterface } from './toViewModel';

export interface StateTreeInterface {
  expandedKeys?: Key[];
  searchValue?: string;
  autoExpandParent?: boolean;
}

class ReportingTreeStore {
  reportingTree: TreeViewInterface[] = [];

  filters: { [index: string]: string | undefined } = {};

  organizationCode: string | null = null;

  stateTree: StateTreeInterface = {
    expandedKeys: [],
    searchValue: '',
    autoExpandParent: true,
  };

  api: CmApi;

  constructor({ api }: { api: CmApi }) {
    this.api = api;
    makeAutoObservable(this);
  }

  setOrganizationCode = (code: string | null) => {
    this.organizationCode = code;
  };

  updateReportingTree = (tree: TreeViewInterface[]) => {
    this.reportingTree = tree;
  };

  setStateTree = (state: StateTreeInterface) => {
    this.stateTree = { ...this.stateTree, ...state };
  };

  setFilters = (value: { [index: string]: string | undefined }) => {
    this.filters = value;
  };

  clear = () => {
    this.organizationCode = null;
    this.reportingTree = [];
    this.filters = {};
    this.stateTree = {
      expandedKeys: [],
      searchValue: '',
      autoExpandParent: true,
    };
  };

  fetch = async (organizationCode: string): Promise<void | TreeViewInterface[]> => {
    preloaderStore.preloader(true);
    try {
      const { data } = await this.api.companyReports.getCompanyReportsTree(organizationCode);

      if (data) {
        runInAction(() => {
          this.reportingTree = data.id ? toViewModel([data] as TreeViewInterface[]) : [];
        });

        return data.id ? toViewModel([data] as TreeViewInterface[]) : [];
      }
    } catch (error) {
      console.error(error);
    } finally {
      preloaderStore.preloader(false);
    }
  };

  getPackageStatusByReportPackageCode = (
    reportPackageCode: string,
    reportingTree = this.reportingTree,
  ): string | undefined => {
    for (const current of reportingTree) {
      if (current.reportPackageCode === reportPackageCode) {
        return current.reportPackageStatus;
      }
      if (current.children) {
        const result = this.getPackageStatusByReportPackageCode(reportPackageCode, current.children);
        if (result) return result;
      }
    }
    return undefined;
  };
}

export const reportingTreeStore = new ReportingTreeStore({
  api: cmApi,
});
